import {post, get, put} from "$lib/api";
import {currentProject} from "$lib/stores/projectWizard";
import {currentCustomer} from "$lib/stores/customer";

let customerUUID:string;
currentCustomer.subscribe(val => {
    if(val && typeof val.uuid !== 'undefined'){
        customerUUID = val.uuid;
    }
})

let project: Project;
currentProject.subscribe(val => {
    if(val){
        project = val;
    }
})
export const storeProject = async () => {
    if(typeof project.uuid !== 'undefined'){
        return await put("/project/" + project.uuid, project);
    }
    return await post("/project/" + customerUUID, project);
}

export const listProjects = async ( conditions:any) => {
    const query =  new URLSearchParams(conditions).toString()
    return await get(`/projects?${query}`);
}

export const getProject = async (uuid:string) => {
    return await get("/project/" + uuid);
}
export const getProjectAssignees = async (uuid:string) => {
    return await get("/project/" + uuid + "/assignees")
}

export const checkIn = async ( projectUuid:string, projectAssignmentId: number) => {
    return await post('/checkin/' + projectUuid, {
        projectAssignmentId
    })
}